<template>
  <div class="d-flex flex-column flex-grow-1">
        <!-- 查询条件区域 -->
    <div class="selector-container d-flex section-container" :class="{'dark':skinType}">
       <SectionTitle title="运维技师" ></SectionTitle>
      <el-form :inline="true" class="section-container d-flex"
      :class="{'dark':skinType}" size="small">
        <el-form-item label="关键字:" :class="{'light-label':skinType}">
          <el-input
            placeholder=""
            v-model="keyWords"
            style="font-size: 0.8rem"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="font-size: 0.8rem" @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table  size="small"
      :data="tableData"
      class="flex-grow-1"
      style="width: 100%"
      stripe
            @row-click="rowClickListener"
      :class="{'dark':skinType}"
      :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column prop="F_RealName" label="姓名"> </el-table-column>
      <el-table-column prop="F_MobilePhone" label="联系方式"> </el-table-column>
      <el-table-column prop="DutyName" label="职位"> </el-table-column>
      <el-table-column prop="DepartmentName" label="部门"> </el-table-column>
      <el-table-column prop="OrganizeName" label="所属项目"> </el-table-column>
    </el-table>
      <div class="d-flex section-container" style="padding:1rem;" :class="{'dark':skinType}">
        <el-pagination
          v-if="pageInfo.total"
          style="margin-left: auto"
          :class="{'text-white':skinType}"
          background
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          :current-page.sync="pageIndex"
        >
        </el-pagination>
      </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { getOperationTechnicians } from '@/api/maintain/maintain';

export default {
  components: {
    SectionTitle,
  },
  data() {
    return {
      pageInfo: {
        index: 1,
        size: 10,
        total: 1,
      },
      tableData: [],
      keyWords: '',
      pageIndex: 1,
    };
  },
  created() {
    this.requestOperationTechnicians();
  },
  watch: {
    pageIndex() {
      this.requestOperationTechnicians();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    onSubmit() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
      } else {
        this.requestOperationTechnicians();
      }
    },
    // 页码监听
    pageChangeListener(pageNo) {
      this.pageIndex = pageNo;
    },
    // 获取运维技师
    requestOperationTechnicians() {
      getOperationTechnicians({
        page: this.pageIndex,
        rows: this.pageInfo.size,
        Keyword: this.keyWords,
      }).then((res) => {
        console.log(res);
        this.tableData = res.list || res;
        this.pageInfo.total = res.total;
      });
    },
    rowClickListener(row) {
      console.log(row);
    },
  },
};
</script>

<style scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
